import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { createEffectFactory } from '@recruitee/ngrx';

import { ReferralsConditionsCollectionHttpClient } from './conditions-collection.http-client';
import { ReferralsConditionsCollectionActions } from './conditions-collection.store';

@Injectable({ providedIn: 'root' })
export class ReferralsConditionsCollectionEffects {
  public effects = createEffectFactory(ReferralsConditionsCollectionActions, this.actions$);

  public fetchCollection$ = this.effects(ReferralsConditionsCollectionActions.fetchCollection, () =>
    this.http.loadConditions().pipe(map(data => ({ data }))),
  );

  public updateCollection$ = this.effects(
    ReferralsConditionsCollectionActions.updateAll,
    ({ payload }) =>
      this.http.updateConditions(payload.conditions).pipe(
        map(conditions =>
          ReferralsConditionsCollectionActions.updateAllSuccess({
            payload: { data: conditions, scope: payload.scope },
          }),
        ),
        catchError(error =>
          of(
            ReferralsConditionsCollectionActions.updateAllFailed({
              payload: { error, scope: payload.scope },
            }),
          ),
        ),
      ),
  );

  constructor(private actions$: Actions, private http: ReferralsConditionsCollectionHttpClient) {}
}
